import { useState } from "react";
import {
  Box,
  Typography,
  Stack,
  ButtonBase
} from "@mui/material";
import { Modal } from '@material-ui/core';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: '300px',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 3,
  maxHeight: '100vh',
  overflowY: 'auto'
};

const TimeTuroTripListContent = (props) => {
  const { timeTuroTripList = [] } = props;

  const [modalOpen, setModalOpen] = useState(false);
  const onClickTimeTuroTripList = (timeTuroTripList) => {
    console.log("onClickTimeTuroTripList::::", timeTuroTripList);
    setModalOpen(true);
  }

  return (
    <>
      <>
        {
          (timeTuroTripList && timeTuroTripList.length > 0) ? (
            <>
              {
                (timeTuroTripList.length > 1) ? (
                  <>
                    <ButtonBase onClick={() => onClickTimeTuroTripList(timeTuroTripList)} disableRipple={true}>
                      <Typography>
                        <span style={{ textDecoration: 'underline', color: 'rgb(19, 102, 255)' }}>
                          Trips
                        </span>
                      </Typography>
                    </ButtonBase>
                  </>
                ) : (
                  <>
                    <a href={`https://turo.com/us/en/reservation/${timeTuroTripList[0].reservation_id}`} target="_blank" rel="noreferrer">
                      <Typography>
                        {timeTuroTripList[0].reservation_id}
                      </Typography>
                    </a>
                  </>
                )
              }
            </>
          ) : (
            <>
              <Typography width={60}>
                -
              </Typography>
            </>
          )
        }
      </>

      <>
        <Modal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          aria-labelledby="parent-modal-title"
          aria-describedby="parent-modal-description"
        >
          <Box sx={modalStyle}>
            <Stack direction={`row`} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography id="modal-modal-title" variant="subtitle" component="h4">{`Turo Trip List`}</Typography>
            </Stack>
            <Box sx={{ mt: 2 }}>
              <Stack direction={`column`} spacing={1}>
                {
                  timeTuroTripList.map((trip, index) => (
                    <a key={index} href={`https://turo.com/us/en/reservation/${trip.reservation_id}`} target="_blank" rel="noreferrer">
                      <Typography component="span">
                        {trip.reservation_id}
                      </Typography>
                    </a>
                  ))
                }
              </Stack>
            </Box>
          </Box>
        </Modal>
      </>
    </>
  )
}

export default TimeTuroTripListContent;
